__turbopack_context__.v({
  "actions": "PortalSectionAccessState-module__rNA0vW__actions",
  "context": "PortalSectionAccessState-module__rNA0vW__context",
  "description": "PortalSectionAccessState-module__rNA0vW__description",
  "panel": "PortalSectionAccessState-module__rNA0vW__panel",
  "primary": "PortalSectionAccessState-module__rNA0vW__primary",
  "secondary": "PortalSectionAccessState-module__rNA0vW__secondary",
  "title": "PortalSectionAccessState-module__rNA0vW__title",
});
